import { Button, Header, Placeholder, Popup } from '@revolut-internal/ui-kit'
import { FC } from 'react'

type Props = {
  message?: string
  description?: string
  open: boolean
  onClose: () => void
}

export const ErrorModal: FC<Props> = props => {
  const { message, description, open, onClose } = props

  return (
    <Popup variant="modal-view" open={open} onClose={onClose}>
      <Header variant="item">
        <Header.CloseButton aria-label="Close" onClick={onClose} />
      </Header>
      <Placeholder p="none" my="-s-24">
        <Placeholder.Image
          src="https://assets.revolut.com/assets/3d-images/3D018.png"
          srcSet="https://assets.revolut.com/assets/3d-images/3D018@2x.png 2x, https://assets.revolut.com/assets/3d-images/3D018@3x.png 3x"
        />
        <Placeholder.Title>{message ?? 'Something went wrong'}</Placeholder.Title>
        {description && <Placeholder.Description>{description}</Placeholder.Description>}
      </Placeholder>
      <Popup.Actions>
        <Button elevated onClick={onClose}>
          Ok, go back
        </Button>
      </Popup.Actions>
    </Popup>
  )
}
